import type { PayloadAction } from '@reduxjs/toolkit';

import type { TGroupType } from 'shared/types/TRankingService';

import type { IOffersState } from 'entities/offers';

import { getOffersToShowFromHiddenOffers } from '../../lib/getOffersToShowFromHiddenOffers';

export const showHiddenOffersReducer = (
  state: IOffersState,
  action: PayloadAction<{ hiddenOfferIds: string[]; targetGroup: TGroupType }>,
) => {
  const { hiddenOfferIds, targetGroup } = action.payload;

  const { offersToShow, remainingHiddenOffers } = getOffersToShowFromHiddenOffers({
    hiddenOffers: state.hiddenOffers,
    hiddenOfferIds,
    targetGroup,
  });

  state.hiddenOffers = remainingHiddenOffers;
  state.offers = [...offersToShow, ...state.offers];
};
